import { css, type SerializedStyles } from '@emotion/react'
import { type Theme } from '@mui/material/styles'

export const odSearchInputPlace = (theme: Theme): SerializedStyles =>
  css({
    paddingRight: theme.spacing(9),
  })
